<script lang="tsx">
import { computed, defineComponent, onMounted, watch } from 'vue';
import { useAppStoreWithOut } from '@/store/modules/app';
import { useUserStore } from '@/store/modules/user';
import { Backtop } from '@/components/Backtop';
import { useDesign } from '@/hooks/web/useDesign';
import { useRenderLayout } from './components/useRenderLayout';
import { useMobileDetect } from '@/hooks/web/useMobileDetect';
import { useRoute } from 'vue-router';
import MobileLayout from './components/MobileLayout.vue';
const { getPrefixCls } = useDesign();

export default defineComponent({
  name: 'Layout',
  setup() {
    const prefixCls = getPrefixCls('layout');
    const appStore = useAppStoreWithOut();
    const userStore = useUserStore();
    const route = useRoute();

    // 是否是移动端
    const mobile = computed(() => appStore.getMobile);

    // 菜单折叠
    const layout = computed(() => appStore.getLayout);

    // 全局加载状态：权限加载或页面加载
    const isGlobalLoading = computed(() => userStore.getIsPermissionLoading || appStore.getPageLoading);

    // 初始化主题
    onMounted(() => {
      appStore.applyTheme(route.meta);
    });

    // 监听路由变化，重新应用主题（确保首页固定暗黑模式生效）
    watch(
      () => route.path,
      () => {
        appStore.applyTheme(route.meta);
      },
      { immediate: false }
    );

    const renderLayout = () => {
      const { renderTopLeft } = useRenderLayout();
      if (mobile.value) {
        return <MobileLayout></MobileLayout>;
      }
      return renderTopLeft();
    };
    useMobileDetect((val) => {
      appStore.setMobile(val);
    });
    return () => (
      <section
        class={[
          prefixCls,
          `${mobile.value ? 'mobile-layout' : 'desktop'}`,
          `${prefixCls}__${layout.value}`,
          'w-[100%] h-[100%] relative',
        ]}
        v-loading={isGlobalLoading.value}
      >
        {renderLayout()}
        <Backtop></Backtop>
      </section>
    );
  },
});
</script>

<style lang="less" scoped>
@prefix-cls: ~'@{adminNamespace}-layout';

.@{prefix-cls} {
  background-color: var(--app-content-bg-color);

  .@{prefix-cls}-content-scrollbar {
    &> :deep(.el-scrollbar__wrap) {
      &>.@{elNamespace}-scrollbar__view {
        display: flex;
        height: 100% !important;
        flex-direction: column;
      }
    }
  }
}

.mobile-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
